import { render, staticRenderFns } from "./ContractorDetails.vue?vue&type=template&id=0c824a47&scoped=true&"
import script from "./ContractorDetails.vue?vue&type=script&lang=js&"
export * from "./ContractorDetails.vue?vue&type=script&lang=js&"
import style0 from "./ContractorDetails.vue?vue&type=style&index=0&id=0c824a47&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c824a47",
  null
  
)

export default component.exports